import React from 'react';

import NotFound from 'components/NotFound';
import CMS1500 from 'components/practice/BeyondBilling/Claims/CMS1500/CMS1500';
import Actions from 'components/practice/charts/Actions/Actions';
import Appointments from 'components/practice/charts/Appointments/Appointments';
import PastAppointments from 'components/practice/charts/Appointments/PastAppointments';
import UpcomingAppointments from 'components/practice/charts/Appointments/UpcomingAppointments';
import CommunicationLogs from 'components/practice/charts/Communications/CommunicationLogs';
import CommunicationMessages from 'components/practice/charts/Communications/CommunicationMessages';
import Communications from 'components/practice/charts/Communications/Communications';
import Demographics from 'components/practice/charts/Demographics/Demographics';
import ChartDocuments from 'components/practice/charts/Documents/ChartDocuments';
import OverviewContainer from 'components/practice/charts/Overview/OverviewContainer';
import PatientChart from 'components/practice/charts/PatientChart/PatientChart';
import PatientCharts from 'components/practice/charts/PatientCharts/PatientCharts';
import PracticePatientSettings from 'components/practice/charts/PracticePatientSettings';
import SuperBillPage from 'components/practice/charts/SuperBillPage/SuperBillPage';
import Billing from 'components/practice/charts/billing/Billing';
import BillingInvoices from 'components/practice/charts/billing/Invoices/PatientInvoices';
import PatientClaims from 'components/practice/charts/billing/claims/PatientClaims';
import Ledger from 'components/practice/charts/billing/ledger/Ledger';
import BillingSuperbill from 'components/practice/charts/billing/superbill/Superbill';
import Transactions from 'components/practice/charts/billing/transactions/Transactions';

import { PRACTICE_CHARTS_ACCOUNT, PRACTICE_CHARTS_CLINICAL_NOTES } from './index';

const PRACTICE_CHARTS = [
  {
    path: 'charts',
    element: <PatientCharts />,
    children: [
      {
        path: ':id',
        element: <PatientChart />,
        children: [
          {
            path: '',
            element: <OverviewContainer />
          },
          ...PRACTICE_CHARTS_CLINICAL_NOTES,
          ...PRACTICE_CHARTS_ACCOUNT,
          {
            path: 'demographics',
            element: <Demographics />
          },
          {
            path: 'appointments/*',
            element: <Appointments />,
            children: [
              {
                path: 'upcoming',
                element: <UpcomingAppointments />
              },
              {
                path: 'past',
                element: <PastAppointments />
              }
            ]
          },
          {
            path: 'eprescribe',
            element: <Actions />
          },
          {
            path: 'billing/*',
            element: <Billing />,
            children: [
              {
                path: 'ledger',
                element: <Ledger />
              },
              {
                path: 'claims',
                element: <PatientClaims />,
                children: [
                  {
                    path: ':claimId',
                    element: <CMS1500 />
                  }
                ]
              },
              {
                path: 'invoices',
                element: <BillingInvoices />
              },
              {
                path: '',
                element: <Transactions />,
                children: [
                  {
                    path: ':transactionId',
                    element: <Transactions />
                  }
                ]
              },
              {
                path: 'superbill',
                element: <BillingSuperbill />,
                children: [
                  {
                    path: ':superbill',
                    element: <SuperBillPage />
                  },
                  {
                    path: 'claim/:claimId',
                    element: <CMS1500 />
                  }
                ]
              },

              {
                path: '*',
                element: <NotFound />
              }
            ]
          },
          {
            path: 'documents',
            element: <ChartDocuments />
          },
          {
            path: 'communications',
            element: <Communications />,
            children: [
              {
                path: '',
                element: <CommunicationMessages />
              },
              {
                path: ':logs',
                element: <CommunicationLogs />
              },
              {
                path: '*',
                element: <NotFound />
              }
            ]
          },
          {
            path: 'settings',
            element: <PracticePatientSettings />
          }
        ]
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
];
export default PRACTICE_CHARTS;
